//nif implementation of axios requests
import store from '@/store';
import axios from 'axios';
import { useOidc } from '@/composables/oidc';

const getUrl = path => `${process.env.VUE_APP_API_URL}/api/v1/${path}`;

const getConfig = config => {
    const { oidcAccessToken: token } = useOidc();

    const currentOrgId = store.getters['contextStore/orgId'];

    const defaultHeaders = {
            Authorization: `Bearer ${token}`,
            'nif-org-id': currentOrgId
    };

    // defaultHeaders is merged with headers from incoming
    // config, if keys are overlapping incoming
    // config will be with priority

    const mergedHeaders = {...defaultHeaders, ...config.headers};

    const result = { ...config, headers: mergedHeaders };

    if (!result?.headers?.Authorization) {
        throw new Error("Missing Authorization token");
    }
    return result;
};

export const get = async function (path, config = {}) {
    const url = getUrl(path);
    const requestConfig = getConfig(config);
    return await axios.get(url, requestConfig);
};

export const post = async function (path, body, config = {}) {
    const url = getUrl(path);
    const requestConfig = getConfig(config);
    return await axios.post(url, body, requestConfig);
};

export const put = async function (path, body, config = {}) {
    const url = getUrl(path);
    const requestConfig = getConfig(config);
    return await axios.put(url, body, requestConfig);
};

export const patch = async function (path, body, config = {}) {
    const url = getUrl(path);
    const requestConfig = getConfig(config);
    return await axios.patch(url, body, requestConfig);
};

export const del = async function (path, config = {}) {
    const url = getUrl(path);
    const requestConfig = getConfig(config);
    return await axios.delete(url, requestConfig);
};
